import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import Walikota from "./pages/Walikota";
import Kota from "./pages/Kota";
import Kerja from "./pages/Kerja";
import Profil from "./pages/Profil";
import Animatic from "./pages/Animatic";
import Diorama from "./pages/Diorama";
import Alun from "./pages/Alun";
import Rumah from "./pages/Rumah";
import Mall from "./pages/Mall";
import Dealer from "./pages/Dealer";
import { ToaBanner } from "./components/toa/ToaBanner";
import { RadioProvider } from "./lib/RadioContext";
import { muatNamaKota, adaCacheNamaKota } from "./components/kota/ui";

// Nama tampilan kota dimuat sekali di awal; bila belum ada cache, tunggu sebentar (maks 1,5 dtk) agar
// pil/KWJ/koran langsung memakai nama yang benar, bukan kapitalisasi ID.
function NamaKotaGate({ children }) {
  const [siap, setSiap] = useState(adaCacheNamaKota());
  useEffect(() => {
    let hidup = true;
    const t = setTimeout(() => hidup && setSiap(true), 1500);
    muatNamaKota().finally(() => { if (hidup) { clearTimeout(t); setSiap(true); } });
    return () => { hidup = false; clearTimeout(t); };
  }, []);
  return siap ? children : null;
}

export default function App() {
  return (
    <NamaKotaGate>
    <RadioProvider>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/walikota" element={<Walikota />} />
      <Route path="/kota/:id" element={<Kota />} />
      <Route path="/alun/:id" element={<Alun />} />
      <Route path="/rumah/:ig" element={<Rumah />} />
      <Route path="/mall" element={<Mall />} />
      <Route path="/dealer" element={<Dealer />} />
      <Route path="/kerja" element={<Kerja />} />
      <Route path="/profil" element={<Profil />} />
      <Route path="/animatic" element={<Animatic />} />
      <Route path="/diorama" element={<Diorama />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    <ToaBanner />
    </RadioProvider>
    </NamaKotaGate>
  );
}
